module.exports = __webpack_public_path__ + "img/coating-water.f5bd48c4.svg";